import { render, staticRenderFns } from "./PlaceItem.vue?vue&type=template&id=3f587d7a"
import script from "./PlaceItem.vue?vue&type=script&lang=js"
export * from "./PlaceItem.vue?vue&type=script&lang=js"
import style0 from "./PlaceItem.vue?vue&type=style&index=0&id=3f587d7a&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports